import Splide from "@splidejs/splide";

export default function initializeTeaserSlider() {
  const items = document.querySelectorAll(".teaser--slider");
  if (!items.length) return;

  function init() {
    items.forEach((item) => {
      createSlider(item);
    });
  }

  function createSlider(item) {
    const el = item.querySelector(".splide");
    const interval = item.dataset.speed * 1000 || 5000;
    const slider = new Splide(el, {
      type: "fade",
      rewind: true,
      autoplay: true,
      interval: interval,
      pauseOnHover: false,
      arrows: false,
      pagination: false,
    });
    slider.mount();
  }

  init();
}
